import React, {useState} from "react";
import BlockButton from "../components/block-button";
import UnderlineButton from "../components/underline-button";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useRecoilValue} from "recoil";
import {CreateWatchOrderResponse, planState,} from "../states/plan-state/plan-atoms";
import {inquireWatchMsisdn, submitSwapOrder, submitWatchOrder} from "../services/pairing-service";
import {OperationResult} from "../models/operation-result";
import {ThreeDots} from "react-loader-spinner";
import {GenericResponse} from "../models/generic-response";
import { Flow } from "../models/flow-enum";

const EmergencyAddress = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { createWatchOrderResponse, emergencyAddress, serviceAddress, inquireCompanionFlowResponse, customerOrderId } = useRecoilValue(planState);
  const [loading, setLoading] = useState(false);

  const submitOrderAndNavigateConfirmation = () => {
    localStorage.setItem("isChangedAddress", "0");
    setLoading(true);
    if (!!createWatchOrderResponse?.pairAccountId) {
      submitSwapOrder(
        {
          ...createWatchOrderResponse,
          capturedAddress: {
            ...createWatchOrderResponse?.capturedAddress,
            parameters: [
              {
                shortCode: "addressType",
                value: "existing",
              }
            ],
          },
          watchInfo: localStorage.getItem("watchInfo")
            ? JSON.parse(localStorage.getItem("watchInfo")!)
            : {},
        } || ({} as CreateWatchOrderResponse),
      )
        .then((response: OperationResult) => {
          if (response.resultCode === "SUCCESS") {
            setLoading(false);
            navigate("/confirmation");
          }
          else {
            navigate('/error');
          }
        })
        .catch((error: any) => {
          setLoading(false);
          navigate('/error');
        });
    } else {
      if (
        createWatchOrderResponse?.capturedAddress?.addrDesc &&
        inquireCompanionFlowResponse?.nextFlowPage !==
          Flow.NON_PAIRED_PLAN_FOUND_ON_OTHER_ACCOUNT &&
        inquireCompanionFlowResponse?.nextFlowPage !== Flow.SINGLE_DEVICE_PAIRED
        &&
        inquireCompanionFlowResponse?.nextFlowPage !== Flow.START_NEW_COMPANION_PLAN
        &&
        inquireCompanionFlowResponse?.nextFlowPage !== Flow.MULTIPLE_DEVICES_PAIRED
      ) {
        submitWatchOrder(
          {
            ...createWatchOrderResponse,
            capturedAddress: createWatchOrderResponse?.capturedAddress,
            watchInfo: localStorage.getItem("watchInfo")
              ? JSON.parse(localStorage.getItem("watchInfo")!)
              : {},
          } || ({} as CreateWatchOrderResponse),
        )
          .then((response: GenericResponse<any>) => {
            if (response.operationResult.resultCode === "SUCCESS") {
              setLoading(false);
              navigate("/confirmation");
            } else {
              navigate('/error');
            }
          })
          .catch((error: any) => {
            setLoading(false);
            navigate('/error');
          });
      }
      else {
        inquireWatchMsisdn({
          serviceAddress: serviceAddress,
          customerOrderId: customerOrderId,
          customerId: inquireCompanionFlowResponse.customerId,
          accountId: inquireCompanionFlowResponse.tmoBillingAccountId,
        }).then(result => {
          if (result.resultCode === "SUCCESS") {
            submitWatchOrder(
              {
                ...createWatchOrderResponse,
                capturedAddress: emergencyAddress,
                watchInfo: localStorage.getItem("watchInfo")
                  ? JSON.parse(localStorage.getItem("watchInfo")!)
                  : {},
              } || ({} as CreateWatchOrderResponse),
            )
              .then((response: GenericResponse<any>) => {
                if (response.operationResult.resultCode === "SUCCESS") {
                  setLoading(false);
                  navigate("/confirmation");
                } else {
                  navigate('/error');
                }
              })
              .catch((error: any) => {
                setLoading(false);
                navigate('/error');
              });
          } else {
            navigate('/error');
          }
        });
      }

    }
  };

  const navigateBackPage = () => {
    navigate("/activate-smartwatch");
  };

  const navigateRegisterAddress = () => {
    localStorage.setItem("isChangedAddress", "1");
    navigate("/register-address");
  };

  return loading ? (
    <ThreeDots
      visible={true}
      height="80"
      width="80"
      color="#FFD200"
      radius="9"
      ariaLabel="three-dots-loading"
      wrapperClass="full-layout"
    />
  ) : (
    <div className="layout-default">
      <h2 className="layout-default-left watch-title">
        {t("emergencyAddressTitle")}
      </h2>
      <p>{t("emergencyAddressInfo")}</p>

      <div className="address-container-start">
        <address>
          <p>{localStorage.getItem("name") || ""}</p>
          <span data-testid="address-text">
            {emergencyAddress?.addrDesc || createWatchOrderResponse?.capturedAddress?.addrDesc}
          </span>
          <br />
        </address>
        <UnderlineButton
          click={navigateRegisterAddress}
          className="underline-button-text-normal cursor-pointer"
          text={t("editLink")}
        />
      </div>
      <div className="mt-3 action-buttons-container-center">
        <BlockButton
          dataTestId="submit-order"
          onClick={submitOrderAndNavigateConfirmation}
          text={t("emergencyAddressButton")}
        />
        <UnderlineButton click={navigateBackPage} text={t("backButton")} />
      </div>
    </div>
  );
};

export default EmergencyAddress;